import { render } from "./Error404Component.vue?vue&type=template&id=066ef205&scoped=true"
import script from "./Error404Component.vue?vue&type=script&lang=js"
export * from "./Error404Component.vue?vue&type=script&lang=js"

import "./Error404Component.vue?vue&type=style&index=0&id=066ef205&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066ef205"]])

export default __exports__